import { render } from "./urgency-callout.vue?vue&type=template&id=1ba7151d"
import script from "./urgency-callout.vue?vue&type=script&lang=js"
export * from "./urgency-callout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__